module.exports = __webpack_public_path__ + "img/title.01815352.png";